import * as _ from "lodash";

// The server omits `itemIds` on a fulfillment line by design when the line is connected to all of the order's items
export function getFulfillmentLineItems<T extends { id?: string }>(fulfillmentLine: { itemIds?: string[] }, items: T[]): T[] {
  const itemIds = fulfillmentLine?.itemIds;
  if (_.isNil(itemIds)) {
    return items || [];
  }
  return _.filter(items, item => _.includes(itemIds, item.id));
}
